import { Avatar, AvatarGroup, Typography } from '@weareopenr/component-library';

import styles from './BrandsAvatarGroup.module.scss';

import { type AvatarGroupProps } from '@weareopenr/component-library/build/components/AvatarGroup/AvatarGroup';
import { type IBrandResponse } from 'src/api/getBrands/types';

interface BrandsAvatarGroupProps {
  brands: IBrandResponse[];
}

const getInitials = (name: string) => {
  if (name.length < 2) return name.toUpperCase();
  return name[0].toUpperCase() + name[1].toLowerCase();
};
const brandToAvatar = (brand: IBrandResponse) => {
  const name = getInitials(brand.name);
  return {
    initials: name,
    variant: 'custom' as const,
    imageUrl: brand.logo_url || undefined,
  };
};

const publishBrandsToAvatars = (brands: IBrandResponse[]): AvatarGroupProps['avatars'] => {
  return brands.map(brandToAvatar);
};

export const BrandsAvatarGroup = ({ brands }: BrandsAvatarGroupProps) => {
  return (
    <AvatarGroup avatars={publishBrandsToAvatars(brands)}>
      <div className={styles['brands-list']}>
        {brands.map((brand) => {
          const av = brandToAvatar(brand);
          return (
            <div key={brand.brand_id} className={styles['brand-item']}>
              <Avatar {...av} />
              <Typography colour="secondary" key={av.initials}>
                {brand.name}
              </Typography>
            </div>
          );
        })}
      </div>
    </AvatarGroup>
  );
};
